export const CONTACT_OPTIONS = [
  {
    id: "linkedin",
    label: "LinkedIn",
    icon: "in",
    description: "View my professional background and connect with me there.",
    actionLabel: "Open LinkedIn",
    href: "https://www.linkedin.com/in/hassanalawie/",
    meta: "External",
  },
  {
    id: "github",
    label: "GitHub",
    icon: "</>",
    description: "Browse my code, experiments, and technical projects.",
    actionLabel: "Open GitHub",
    href: "https://github.com/hassanalawie",
    meta: "External",
  },
];
